import {useState} from "react";
import SessionWrapUpAudio from "../resources/audio/session-wrapup-notification.mp3";
import SilentAudio from "../resources/audio/silent-audio-notification.mp3";
import {
    calculateDurationToPlayAlert,
    constructAudioBufferAndPlayAlert
} from "../helpers/AudioUtils";

export function useSessionLaunch(selectedEvent) {
    const [isSessionLaunchedByPerformer, setIsSessionLaunchedByPerformer] = useState(false);

    const handleSessionLaunch = async (event) => {
        event.preventDefault();

        const {from, disableLaunchSessionAfterMinutes} = selectedEvent;

        const countdownToAlertInSeconds = await calculateDurationToPlayAlert(
            from,
            disableLaunchSessionAfterMinutes
        );

        if (countdownToAlertInSeconds > 0 && !isSessionLaunchedByPerformer) {
            await constructAudioBufferAndPlayAlert(
                SilentAudio,
                SessionWrapUpAudio,
                countdownToAlertInSeconds
            );
        }

        setIsSessionLaunchedByPerformer(true);
        window.open(selectedEvent.zoomMeetingUrl, '_blank', 'noopener,noreferrer');
    };

    return {
        handleSessionLaunch,
        isSessionLaunchedByPerformer
    };
}
